module.exports = __webpack_public_path__ + "static/img/why-5.7714b488.jpg";